import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.scoped.css';
import { analytics } from '../../../utils/firebase';
import classNames from '../../../utils/classNames';
import { logEvent } from 'firebase/analytics';
import { Flex } from '@mantine/core';


function Button({
  children = null,
  className = '',
  disabled = false,
  eventName = 'button_click',
  eventParams = {},
  fullWidth = false,
  onClick = () => { },
  outlined = false,
  size = 'large',
  style = 'default',
  title = '',
  type = 'button',
  icon = null,
}) {
  const classes = classNames(
    styles['root'],
    outlined && styles['outlined'], styles[style],
    className,
    styles[size],
    fullWidth && styles['fullWidth']
  );
  const onBtnClick = () => {
    logEvent(analytics, eventName, eventParams);
    onClick && onClick();
  };

  return (
    <button
      className={classes}
      disabled={disabled}
      onClick={onBtnClick}
      title={title}
      type={type}
    >
      <Flex align="center" gap="sm" justify="center">
        {icon}
        {children}
      </Flex>
    </button>
  );
}

export default Button;

Button.defaultProps = {
  children: null,
  className: '',
  disabled: false,
  eventName: 'button_click',
  eventParams: {},
  fullWidth: false,
  onClick: () => {},
  outlined: false,
  size: 'large',
  style: 'blue',
  title: '',
  type: 'button',
  icon: null,
};


Button.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  eventName: PropTypes.string,
  eventParams: PropTypes.object,
  fullWidth: PropTypes.bool,
  icon: PropTypes.node,
  onClick: PropTypes.func,
  outlined: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  style: PropTypes.oneOf([
    'default',
    'danger',
    'light-danger',
    'success',
    'light-success',
    'blue',
    'outlined',
    'transparent',
    'primary-500',
  ]),
  title: PropTypes.string,
  type: PropTypes.string,
};
